export default __webpack_public_path__ + "_/common/src/assets/downloads/flush.mp3";